import { storageFactory } from "storage-factory";

export const localStorage = storageFactory(() => window.localStorage);

const localStorageKey = "persist:language";
type Iso639LanguageCode = "sv" | "nb" | "en" | "dn";

export const getLanguageFromLocalStorage = () => {
  return localStorage.getItem(localStorageKey);
};

export const saveLanguageToLocalStorage = (language: Iso639LanguageCode) => {
  return localStorage.setItem(localStorageKey, language);
};

export function isIso639Code(lang: string): lang is Iso639LanguageCode {
  return ["sv", "nb", "en", "dn"].includes(lang);
}
